import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    mailings: [],
    mailingModelDef: {
        id: null,
        bot_id: 1,
        message_id: null,
        title: 'Рассылка',
        status: 'primary',
        start_time: null,
        created_at: null,
        updated_at: 0,
        type_list: 2,
        sex: null,
        old: null,
        city: null,
        old_par: null,
        // working: 0,
        params: null,
        text_found: 0,
        vote_id: null,
        text: '',
        keyboard_id: null,
        location: null,
        dont_parse_links: 1,
        message: 0,
        attachment: null,
        all_users: null,
        delivered: null,
        readed: null,
        platform: 'vk',
        group_ids: '',
        excepts: '',
        module_group_id: 0,
        jump_checker: 0,
        car_model: null,
        car_number: null,
        count_order: null,
        count_order_period: 1
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
